module.exports = __webpack_public_path__ + "images/79ecdc73f1eaead29cf1d1322678f4ac-IMG_5522.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_5522.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_5522.jpg
// module chunks = 0